import React from 'react'
import styled, { css } from 'styled-components'

const width = '17'
const height = '16'
const viewBox = '0 0 17 16'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#FFF"
      d="M14.992 0c.65 0 1.18.514 1.18 1.147v13.626c0 .634-.53 1.149-1.18 1.149H1.425c-.648 0-1.175-.515-1.175-1.15V1.148C.25.514.777 0 1.425 0h13.567zm-1.175 13.568V9.4c0-2.047-.442-3.62-2.831-3.62-1.15 0-1.92.63-2.235 1.227h-.032V5.97H6.453v7.598h2.361v-3.76c0-.99.187-1.95 1.416-1.95 1.21 0 1.228 1.133 1.228 2.015v3.695h2.359zM3.79 4.93a1.37 1.37 0 1 0-.003-2.74 1.37 1.37 0 0 0 .003 2.74zm-1.182 8.637h2.363V5.97H2.609v7.598z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'LogoSocialLinkedin'
})
